module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/vi_okinawa-18ba4561896832679be89345bb242e15.jpg";